import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'
import { insuranceParamsContext } from '../layouts/Wizard'

import { useSaveVehicleAdditionalInfo } from '@/hooks/useWizard'
import type { AddVehicleInfoFormValues } from './AddVehicleInfoForm'
import { AddVehicleInfoForm } from './AddVehicleInfoForm'

export const AddVehicleInfo = () => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const toast = useToast()

  const handleOpenModalClick = () => {
    onOpen()
  }

  const handleModalClose = () => {
    onClose()
    setError(null)
  }

  const { insuranceParamsId, refetchInsuranceParams } = useContext(insuranceParamsContext)
  const { mutateAsync: saveVehicleAdditionalInfo, isLoading: isLoading } = useSaveVehicleAdditionalInfo()
  const [error, setError] = useState<string | null>(null)

  const handleFormSubmit = (values: AddVehicleInfoFormValues) =>
    saveVehicleAdditionalInfo({
      licencePlate: values.registration,
      paramsId: +insuranceParamsId!,
      technicalCertificateNumber: values.tpNumber,
      registrationCertificateNumber: values.orvNumber
    })
      .then(({ data }) => {
        toast({
          title: 'Informace byly odeslány do systému pojišťovny.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        })
        refetchInsuranceParams() // refreshneme udaje o aute v contextu
        onClose()
      })
      .catch((data) => {
        if (data.response.status === 400) {
          setError(Object.values(data.response.data).join(', '))
          return
        }

        toast({
          title: data.response.data.text ?? 'Chyba při odesílání informací do pojišťovny',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })

        setError(data.response.data.text)
      })

  return (
    <Box>
      <Button variant="outline" onClick={handleOpenModalClick} isLoading={isLoading}>
        Doplnit údaje o vozidle (RZ a TP)
      </Button>

      <Modal isOpen={isOpen} onClose={handleModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Doplnit údaje o vozidle</ModalHeader>

          <ModalBody>
            <AddVehicleInfoForm onSubmit={handleFormSubmit} />

            {error &&
              <Box mt={4}>
                <Text variant='error'>
                  {error}
                </Text>
              </Box>
            }
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
